"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarEventResultModelType = void 0;
const CalendarEventResultModel_1 = __importDefault(require("../event-result/CalendarEventResultModel"));
class CalendarEventResultModelType {
}
exports.CalendarEventResultModelType = CalendarEventResultModelType;
class VasCalEventResultModelFactory {
    constructor() {
        this.eventResultModels = new CalendarEventResultModel_1.default();
    }
    getEventResultModels() {
        return {
            Day: this.eventResultModels.DayEventResult,
            Slot: this.eventResultModels.SlotEventResult,
            VisibleDaysChange: this.eventResultModels.NextPrevDaysChangeEventResult,
            CalReloaded: this.eventResultModels.CalReloadedEventResult,
            CalReloading: this.eventResultModels.CalReloadingEventResult
        };
    }
    ;
}
exports.default = VasCalEventResultModelFactory;
